// material-ui
// import { Typography } from '@mui/material';

// project imports
// import MainCard from 'ui-component/cards/MainCard';
import ProcessList from 'views/application/process/list/ProcessList';

// ==============================|| SAMPLE PAGE ||============================== //

const SamplePage = ({ process }: { process: string }) => (
    // <MainCard title="Inventory">
    <ProcessList process={process} />
    // </MainCard>
);

export default SamplePage;
